// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Field from "../layout-and-structure/Field.res.js";
import * as React from "react";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "borderColor-kVAM5u": "borderColor-x9r1u3d",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "gap-kOIVth": "gap-x1jnr06f",
    "justifyContent-kjj79g": "justifyContent-x1qughib",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:12"
  },
  filter: {
    "backgroundColor-kWkggS": "backgroundColor-x1j3d9h6",
    "height-kZKoxP": "height-x5kalc8",
    "paddingInline-kg3NbH": "paddingInline-xqin4a2",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:24"
  },
  field: {
    "backgroundColor-kWkggS": "backgroundColor-x17suf5r",
    "borderColor-kVAM5u": "borderColor-x1t4mavk",
    "height-kZKoxP": "height-x1vqgdyp",
    "paddingInline-kg3NbH": "paddingInline-xaope02",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:29"
  },
  text: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1qgc9lc",
    "letterSpacing-kb6lSQ": "letterSpacing-x1owzkzt",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "minWidth-k7Eaqz": "minWidth-xeuugli",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:41"
  },
  textLabel: {
    "color-kMwMTN": "color-x1qqs05d",
    "letterSpacing-kb6lSQ": "letterSpacing-x1yrajzq",
    "minWidth-k7Eaqz": "minWidth-x13qp9f6",
    "paddingRight-kpe85a": "paddingRight-x1xpa7k",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:49"
  },
  textDisabled: {
    "color-kMwMTN": "color-x1d0e3gf",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:55"
  },
  filterActive: {
    "backgroundColor-kWkggS": "backgroundColor-xcv289a",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:58"
  },
  fieldActive: {
    "borderColor-kVAM5u": "borderColor-xsdecx7",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:61"
  },
  filterDisabled: {
    "backgroundColor-kWkggS": "backgroundColor-xcv289a",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:64"
  },
  fieldDisabled: {
    "backgroundColor-kWkggS": "backgroundColor-xhb2u9n",
    "borderColor-kVAM5u": "borderColor-x1fs2082",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:67"
  },
  filterFocused: {
    "borderColor-kVAM5u": "borderColor-xsdecx7",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:71"
  },
  filterHighlighted: {
    "borderColor-kVAM5u": "borderColor-x1lkidjr",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:74"
  },
  fieldFocused: {
    "borderColor-kVAM5u": "borderColor-x1lkidjr",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:77"
  },
  fieldHighlighted: {
    "borderColor-kVAM5u": "borderColor-x1e8c15n",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:80"
  },
  fieldFocusedAndErrored: {
    "borderColor-kVAM5u": "borderColor-xm4gsbn",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:83"
  },
  fieldErrored: {
    "borderColor-kVAM5u": "borderColor-x1p02d27",
    $$css: "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:86"
  }
};
function filterStyleProps(hovered, focused, active, highlighted, disabled, size) {
  return Stylex.props(styles.root, styles.filter, disabled ? styles.filterDisabled : active || hovered ? styles.filterActive : {}, highlighted ? styles.filterHighlighted : {}, focused ? styles.filterFocused : {}, size === "normal" ? {} : {
    borderRadius: "4px",
    height: "30px",
    padding: "8px" + ` ` + "12px"
  });
}
function fieldStyleProps(hovered, focused, active, highlighted, disabled, errored, size) {
  return Stylex.props(styles.root, styles.field, disabled ? styles.fieldDisabled : active || hovered ? styles.fieldActive : {}, focused ? errored ? styles.fieldFocusedAndErrored : styles.fieldFocused : errored ? styles.fieldErrored : {}, highlighted ? styles.fieldHighlighted : {}, size === "normal" ? {
    minWidth: "160px"
  } : {
    borderRadius: "4px",
    height: "30px",
    minWidth: "130px",
    paddingBlock: "8px",
    paddingInline: "12px"
  });
}
function textStyleProps(disabled, size, label, grow) {
  return Stylex.props(styles.text, label ? styles.textLabel : {}, disabled ? styles.textDisabled : {}, {
    flexGrow: grow ? "1" : "0"
  }, size === "normal" ? {
    fontSize: "15px"
  } : {
    fontSize: "13px"
  });
}
function OverlayTriggerView(props) {
  let __disabled = props.disabled;
  let __highlighted = props.highlighted;
  let __focused = props.focused;
  let __active = props.active;
  let hovered = props.hovered;
  let __hideIcon = props.hideIcon;
  let icon = props.icon;
  let label = props.label;
  let __growContent = props.growContent;
  let __size = props.size;
  let preset = props.preset;
  let children = props.children;
  let size = __size !== undefined ? __size : "normal";
  let growContent = __growContent !== undefined ? __growContent : false;
  let hideIcon = __hideIcon !== undefined ? __hideIcon : false;
  let active = __active !== undefined ? __active : false;
  let focused = __focused !== undefined ? __focused : false;
  let highlighted = __highlighted !== undefined ? __highlighted : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let name = icon !== undefined ? icon : active ? "arrow_up_light" : "arrow_down_light";
  let size$1 = size === "normal" ? 20 : 16;
  let fill = highlighted ? "#25243a" : hovered || focused ? "#535165" : "#797885";
  let iconComponent = JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(LegacyIcon.make, {
      name: name,
      fill: fill,
      size: size$1
    }),
    style: {
      display: "flex",
      marginRight: "-1px",
      paddingLeft: "2px"
    }
  });
  let match = typeof preset === "object" ? fieldStyleProps(hovered, focused, active, highlighted, disabled, Stdlib_Option.isSome(preset.VAL.errorMessage), size) : filterStyleProps(hovered, focused, active, highlighted, disabled, size);
  let style = match.style;
  let className = match.className;
  let match$1 = {
    className: "alignItems-x6s0dn4 display-x78zum5 gap-x1nejdyq minWidth-xeuugli",
    "data-style-src": "wino-gc:src/resources/overlays/OverlayTriggerView.res.js:35"
  };
  let match$2 = textStyleProps(disabled, size, true, growContent);
  let match$3 = textStyleProps(disabled, size, false, growContent);
  let textStyle = match$3.style;
  let textClassName = match$3.className;
  if (typeof preset !== "object") {
    return JsxRuntime.jsxs("div", {
      children: [JsxRuntime.jsxs("div", {
        children: [label !== undefined ? JsxRuntime.jsx("span", {
          children: label + (I18n.t(":") + " "),
          className: match$2.className,
          style: match$2.style
        }) : null, JsxRuntime.jsx("span", {
          children: children,
          className: textClassName,
          style: textStyle
        })],
        className: match$1.className,
        style: match$1.style
      }), hideIcon ? null : iconComponent],
      className: className,
      style: style
    });
  }
  let match$4 = preset.VAL;
  return JsxRuntime.jsx(Field.make, {
    children: JsxRuntime.jsxs("div", {
      children: [JsxRuntime.jsx("span", {
        children: children,
        className: textClassName,
        style: textStyle
      }), hideIcon ? null : iconComponent],
      className: className,
      style: style
    }),
    label: label,
    tooltip: match$4.tooltip,
    errorMessage: match$4.errorMessage,
    required: match$4.required
  });
}
let make = React.memo(OverlayTriggerView);
export { make };
/* styles Not a pure module */